/* Uta Meinke - Rabattstaffel im Warenkorb. Vanilla JS, keine Abhaengigkeiten. */
(function () {
  'use strict';
  var TIERS = [{q:2,p:10},{q:3,p:15},{q:4,p:20}];
  var NB = ' ';
  var stepsBuilt = false;

  function el(){ return document.querySelector('[data-um-progress]'); }

  function buildSteps(box){
    if (stepsBuilt) return;
    var host = box.querySelector('[data-um-steps]');
    if (!host) return;
    host.innerHTML = TIERS.map(function(t){
      return '<span class="um-progress__step" data-um-step="' + t.q + '">' + t.q + ' Artikel' + NB + '·' + NB + t.p + NB + '%</span>';
    }).join('');
    stepsBuilt = true;
  }

  function setCount(count){
    var c = document.querySelector('[data-um-count]');
    if (!c) return;
    c.textContent = count > 0 ? (count === 1 ? '1 Artikel' : count + ' Artikel') : '';
  }

  function render(count){
    setCount(count);
    var box = el();
    if (!box) return;

    if (count < 1) { box.setAttribute('hidden', ''); return; }
    box.removeAttribute('hidden');
    buildSteps(box);

    var msg  = box.querySelector('[data-um-msg]');
    var fill = box.querySelector('[data-um-fill]');
    var top  = TIERS[TIERS.length - 1];
    var reached = null, next = null;

    for (var i = 0; i < TIERS.length; i++) {
      if (count >= TIERS[i].q) reached = TIERS[i];
      else { next = TIERS[i]; break; }
    }

    fill.style.width = Math.min(100, Math.round((count / top.q) * 100)) + '%';

    var missing = next ? (next.q - count) : 0;
    var word = missing === 1 ? 'Artikel' : 'Artikel';

    if (!reached && next) {
      msg.className = 'um-progress__msg';
      msg.innerHTML = 'Noch <b>' + missing + ' ' + word + '</b> bis <b>' + next.p + NB + '% Rabatt</b>.';
    } else if (reached && next) {
      msg.className = 'um-progress__msg';
      msg.innerHTML = '<b>' + reached.p + NB + '% Rabatt</b> gesichert &ndash; noch <b>' + missing + ' ' + word + '</b> bis <b>' + next.p + NB + '%</b>.';
    } else if (reached) {
      msg.className = 'um-progress__msg um-progress__msg--done';
      msg.innerHTML = 'Bestm&ouml;glicher Rabatt gesichert: <b>' + reached.p + NB + '%</b>.';
    }

    var stepEls = box.querySelectorAll('[data-um-step]');
    for (var j = 0; j < stepEls.length; j++) {
      var q = parseInt(stepEls[j].getAttribute('data-um-step'), 10);
      stepEls[j].classList.toggle('um-progress__step--on', count >= q);
    }
  }

  var busy = false, again = false;
  function refresh(){
    if (busy) { again = true; return; }
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(c){ render(c.item_count || 0); })
      .catch(function(){})
      .then(function(){
        busy = false;
        if (again) { again = false; refresh(); }
      });
  }

  function watch(){
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    var target = drawer.querySelector('[data-products]');
    if (!target) return;
    new MutationObserver(function(){ refresh(); }).observe(target, { childList: true, subtree: true });
  }

  function init(){
    refresh();
    watch();
    ['cart:updated','cart:build','ajaxProduct:added','cart:refresh'].forEach(function(ev){
      document.addEventListener(ev, refresh);
    });
    document.addEventListener('click', function(e){
      if (e.target.closest && e.target.closest('.js-drawer-open-cart, [data-add-to-cart], .cart__remove, .js-qty__adjust')) {
        setTimeout(refresh, 450);
      }
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
